


















































import Vue from 'vue';
import * as avvocatoApi from '../services/avvocato-api';
import { AvvocatoList, AvvocatoListViewModel } from '../types';

export default Vue.extend({
    data(): AvvocatoListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.avvocato'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.email'),
                    value: 'email',
                },
                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await avvocatoApi.getList();
        },
        showDetail(item: AvvocatoList) {
            this.$router.push({
                name: 'AvvocatoDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await avvocatoApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
